module.exports = __webpack_public_path__ + "img/shifanqiye.33524dd9.png";